<script>
  export let number = 0;
  export let units = 'things';
  let className = undefined;
  export {className as class};

</script>

<div class="stat-card { className ? className : '' }">
  <p class="stat">{ number }
    <span class="units">{ units }</span>
  </p>
</div>

<style>
  .stat-card {
  padding: 1rem;
  /*background-color: #FFF;*/
  text-align: center;
  }

  .stat {
  color: #e00122;
  font-size: 4rem;
  line-height: 2.5rem;
  padding: 0;
  margin: 0 auto;
  font-weight: 300;
  }

  .units {
  display: block;
  color: #000000;
  font-size: 2rem;
  padding: 0;
  font-weight: 700;
  margin: 1.5rem 0 0;
  text-transform: uppercase;
  }
</style>